import {
  Checkbox as MuiCheckbox,
  CheckboxProps,
  FormControlLabel
} from '@mui/material';
import {
  CompositeFilterDescriptor,
  FilterDescriptor
} from '@progress/kendo-data-query';
import React from 'react';

interface Props {
  label: string;
  errorMessage?: string;
  displayError?: boolean;
  disabled?: boolean;
}

export const Checkbox = React.forwardRef<
  HTMLInputElement,
  Props & CheckboxProps
>((props, ref) => {
  const { label, id, disabled, className, ...rest } = props;
  return (
    <FormControlLabel
      className={className ?? ''}
      disabled={disabled}
      id={id}
      label={label}
      ref={ref}
      control={<MuiCheckbox {...rest} />}
    />
  );
});

Checkbox.defaultProps = {
  disabled: false
};

export const getCheckboxFilterState = (
  filter: CompositeFilterDescriptor | undefined,
  removeFilter: boolean,
  field: string,
  operator: string,
  value: Nullable<string>
): CompositeFilterDescriptor | undefined => {
  const filters = (filter?.filters ?? []).filter(
    f =>
      (f as FilterDescriptor).field !== field ||
      (f as CompositeFilterDescriptor).logic === 'or'
  );
  if (!removeFilter) {
    return {
      ...(filter ?? {}),
      filters: [
        ...filters,
        {
          field: field,
          operator: operator,
          value: value
        }
      ]
    } as CompositeFilterDescriptor;
  }

  return filter ? { ...filter, filters: [...filters] } : undefined;
};
